import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { EnvConfig } from "../models/env-config";
import { SessionStorageService } from "./session-storage.service";
import { StyleManager } from "./style-manager.service";
import { HttpClient } from "@angular/common/http";
import { catchError, tap } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class ThemeService {
  currentIssuer: string = "";

  constructor(private styleManager: StyleManager,
    @Inject(DOCUMENT) private document: Document,
    private localStorageService: SessionStorageService,
    private httpClient: HttpClient
    ) {}

  setTheme(emissor: string, productId?: string): any {
    this.currentIssuer = emissor;

    let cssStyleFilePath = productId ? '/style-productId-' + productId + '.css' : 'style.css';
    
    let themeUrl = environment.production
      ? `${environment.filesUrl}/assets/temas/${emissor}`
      : `assets/temas/${emissor}`;

    this.httpClient.get(`${themeUrl}${cssStyleFilePath}`, {
      observe: 'body',
      responseType: 'text',
    })
    .pipe(
      catchError(err => {
        if(cssStyleFilePath.match(/\/\w+-\w+-\d+\.css/g)){
          return this.httpClient.get(`${themeUrl}/style.css`, {
            observe: 'body',
            responseType: 'text',
          }).pipe(
            tap(r => cssStyleFilePath = '/style.css'),
            catchError(err => {
              cssStyleFilePath = '/style.css';
              console.log(`${themeUrl}${cssStyleFilePath}`);
              this.styleManager.setStyle("theme", `${themeUrl}${cssStyleFilePath}`);
              throw 'Erro ao buscar arquivo. ';
            })
            );
        }
        throw 'Erro ao buscar arquivo. ';
      })
    )
    .subscribe(cssResponse => {
      this.styleManager.setStyle("theme", `${themeUrl}${cssStyleFilePath}`);
    });
    
    this.loadFavIcon(emissor);
  }

  loadFavIcon(emissor: string) {
    const head = this.document.getElementsByTagName("head")[0];

    let themeUrl = environment.production
      ? `${environment.filesUrl}/assets/temas/${emissor}/favicon.ico`
      : `favicon.ico`;

    const style = this.document.createElement("link");
    style.rel = "icon";
    style.type = "image/x-icon";
    style.href = themeUrl;

    head.appendChild(style);
    const envConfig: EnvConfig = this.localStorageService.getEnvConfig();
    const title = this.document.createElement("title");
    title.innerHTML = envConfig.appTitle || "Auto Captação";

    head.appendChild(title);
  }

  getIssuer(input: string) {
    let regex = /-\w+\./g;
    let values = input.match(regex) || [];
    return values[0]?.substring(1, values[0]?.length - 1);
  }

  getCurrentIssuer(): string {
    return this.currentIssuer;
  }

  getThemeFromUrl() {
    let theme = "default";
    let issuerFromDomain = this.getIssuer(window.location.href);
    if (issuerFromDomain) {
      theme = issuerFromDomain;
    } else {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      let issuerFromParam = urlParams.get("theme");
      if (issuerFromParam) {
        theme = issuerFromParam;
      }
    }

    // let theme = mapaEmissores.default;
    // for (const nomeEmissor in mapaEmissores) {
    //   if (window.location.href.indexOf(nomeEmissor) > -1) {
    //     theme = nomeEmissor;
    //     break;
    //   }
    // }

    return theme;
  }

  getColorTheme(): { colorPrimary: string; colorSecondary: string } {
    const csssStyleDeclaration: CSSStyleDeclaration = getComputedStyle(
      document.documentElement
    );

    const colorPrimary = csssStyleDeclaration
      .getPropertyValue("--color-primary")
      .replace(/\s/g, "");
    const colorSecondary = csssStyleDeclaration
      .getPropertyValue("--color-secondary")
      .replace(/\s/g, "");

    return {
      colorPrimary: colorPrimary ? colorPrimary : "#00345B",
      colorSecondary: colorPrimary ? colorSecondary : "#f11158",
    };
  }
}
